module.exports = __webpack_public_path__ + "img/book_5_zh.091c0d48.png";